import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "content-centered large event-container"
  }, [_c("BackgroundVideo"), _c("div", {
    staticClass: "container-centered small content"
  }, [_vm.event.logoUrl ? _c("img", {
    staticClass: "event-logo",
    attrs: {
      src: _vm.event.logoUrl
    }
  }) : _vm._e(), _vm.event.firstParagraph ? _c("p", {
    staticClass: "paragraph",
    domProps: {
      innerHTML: _vm._s(String.nl2br(_vm.event.firstParagraph))
    }
  }) : _vm._e(), _vm.event.secondParagraphTitle ? _c("div", {
    staticClass: "bold"
  }, [_vm._v(" " + _vm._s(_vm.event.secondParagraphTitle) + " ")]) : _vm._e(), _vm.event.secondParagraph ? _c("p", {
    staticClass: "paragraph",
    domProps: {
      innerHTML: _vm._s(String.nl2br(_vm.event.secondParagraph))
    }
  }) : _vm._e(), _vm.event.mailToTitle ? _c(VBtn, {
    staticClass: "primary-button",
    on: {
      click: function click($event) {
        return _vm.sendMail(_vm.event.mailToEmail);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.event.mailToTitle) + " ")]) : _vm._e(), _c("div", [_vm.event.leftText ? _c("div", {
    staticClass: "esssentialInfo bold"
  }, [_vm.event.leftText ? _c("span", {
    staticClass: "link",
    class: _vm.event.leftTextLink ? "clickable" : "",
    on: {
      click: function click($event) {
        return _vm.openUrl(_vm.event.leftTextLink);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.event.leftText) + " ")]) : _vm._e(), _vm.event.leftText && _vm.event.rightText ? _c(VDivider, {
    staticClass: "divider",
    attrs: {
      vertical: ""
    }
  }) : _vm._e(), _vm.event.rightText ? _c("span", {
    staticClass: "link",
    class: _vm.event.rightTextLink ? "clickable" : "",
    on: {
      click: function click($event) {
        return _vm.openUrl(_vm.event.rightTextLink);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.event.rightText) + " ")]) : _vm._e()], 1) : _vm._e(), _vm.event.bottomSmallerText ? _c("div", {
    staticClass: "bold text-smaller"
  }, [_vm._v(" " + _vm._s(_vm.event.bottomSmallerText) + " ")]) : _vm._e()]), _vm.event.primaryButtonText ? _c("div", {
    attrs: {
      id: "primary-button-container"
    }
  }, [_c(VBtn, {
    staticClass: "primary-button",
    attrs: {
      href: _vm.event.primaryButtonLink,
      target: "_blank"
    }
  }, [_vm._v(" " + _vm._s(_vm.event.primaryButtonText) + " ")])], 1) : _vm._e(), _vm.event.footerParagraph ? _c("p", {
    staticClass: "text-smaller paragraph",
    domProps: {
      innerHTML: _vm._s(String.nl2br(_vm.event.footerParagraph))
    }
  }) : _vm._e()], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };